if ('ontouchstart' in document.documentElement) {
	document.documentElement.classList.add('sh-is-touchscreen');
}
